// @/locales/lang/en-US/pamm-assets.ts
export default {
  tabs: {
    subscribed: 'Subscribed',
    subscriptionRecords: 'Subscription Records',
    profitSharingRecords: 'Profit Sharing Records'
  },
  search: {
    placeholder: 'Search by PAMM name or manager name',
    status: 'Status',
    type: 'Type',
    startTime: 'Start Time',
    confirm: 'Confirm',
    reset: 'Reset'
  },
  table: {
    settlementCycle: {
      week: 'Weekly Settlement'
    },
    manager: {
      noName: 'No Manager Name'
    },
    status: {
      pendingRedemption: 'Pending Redemption',
      ongoing: 'Ongoing',
      redeemed: 'Redeemed',
      stopped: 'Stopped'
    },
    applyType: {
      subscribe: 'Subscribe',
      add: 'Add',
      redeem: 'Redeem',
      liquidate: 'Liquidate'
    },
    checkStatus: {
      pending: 'Pending',
      approved: 'Approved',
      rejected: 'Rejected'
    },
    period: {
      to: 'to'
    },
  }
}
